var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { defineStore } from "pinia";
import { computed, ref, set } from "vue";
// import type { StoredWorkflowDetailed } from "@/api/workflows"; // TODO: use this instead of locally defined type
import { getAppRoot } from "@/onload/loadConfig";
import {} from "@/stores/workflowStepStore";
export const useWorkflowStore = defineStore("workflowStore", () => {
    const workflowsByInstanceId = ref({});
    const getStoredWorkflowByInstanceId = computed(() => (workflowId) => {
        return workflowsByInstanceId.value[workflowId];
    });
    const getStoredWorkflowIdByInstanceId = computed(() => (workflowId) => {
        const storedWorkflow = workflowsByInstanceId.value[workflowId];
        return storedWorkflow === null || storedWorkflow === void 0 ? void 0 : storedWorkflow.id;
    });
    const getStoredWorkflowNameByInstanceId = computed(() => (workflowId, defaultName = "...") => {
        const details = workflowsByInstanceId.value[workflowId];
        if (details && details.name) {
            return details.name;
        }
        else {
            return defaultName;
        }
    });
    // stores in progress promises to avoid overlapping requests
    const workflowDetailPromises = new Map();
    /**
     * Fetches workflow details, avoiding multiple fetches occurring simultaneously
     * @param workflowId instance id of workflow to fetch
     */
    function fetchWorkflowForInstanceId(workflowId) {
        return __awaiter(this, void 0, void 0, function* () {
            const promise = workflowDetailPromises.get(workflowId);
            if (promise) {
                console.debug("Workflow details fetching already requested for", workflowId);
                yield promise;
            }
            else {
                console.debug("Fetching workflow details for", workflowId);
                const params = { instance: "true" };
                const promise = axios.get(`${getAppRoot()}api/workflows/${workflowId}`, { params });
                workflowDetailPromises.set(workflowId, promise);
                const { data } = yield promise;
                set(workflowsByInstanceId.value, workflowId, data);
            }
            workflowDetailPromises.delete(workflowId);
        });
    }
    /**
     * Fetches workflow details only if they are not already in the store
     * @param workflowId instance id of workflow to maybe fetch
     */
    function fetchWorkflowForInstanceIdCached(workflowId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!Object.keys(workflowsByInstanceId.value).includes(workflowId)) {
                yield fetchWorkflowForInstanceId(workflowId);
            }
        });
    }
    return {
        workflowsByInstanceId,
        getStoredWorkflowByInstanceId,
        getStoredWorkflowIdByInstanceId,
        getStoredWorkflowNameByInstanceId,
        fetchWorkflowForInstanceId,
        fetchWorkflowForInstanceIdCached,
    };
});
